import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { DeviceListScene } from 'scenes';

import { Typeof } from 'utils';

import axios from 'axios';

class DeviceListContainer extends AbstractContainer {

  getTasks() {

    return [
      {
        key: 'clinics',
        exec: (done, failure) => {
          API.get('clinics')
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
      {
        key: 'devices',
        exec: (done, failure) => {
          API.get('devices')
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
      {
        key: 'appstore',
        exec: (done, failure) => {
          // fetch('https://itunes.apple.com/lookup?bundleId=com.lim-group.equisym&country=fr', 
          // { method: 'GET',
          // mode: 'cors',
          // cache: 'default' })
          // .then(response => response.json())
          //   .then((data) => {
          //     done(data);
          //   })
          //   .catch(failure);
          done({results:[{version:"1.4.2"}]})
        }
      }
    ]
  }

  getComponent(results) {

    let devices = results.devices.map((device) => {

      if(Typeof.object(device.clinic)) {

        //Get clinic of device
        let clinic = results.clinics.find((clinic) => clinic.id === device.clinic.id);
        device.clinic = clinic;
      }

      return device;
    });

    return <DeviceListScene devices={devices} appStoreVersion={results.appstore.results[0].version} />
  }
}

export default DeviceListContainer;
